<template>
  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix">
      <p style="display: inline-block;padding-left:92px">目录预览</p>
      <el-button style="color:var(--theme-color)!important;margin-left: 15px;" :loading="loading" type="text" @click="refresh">
        预览
      </el-button>
    </div>
    <el-tree v-if="show" :props="defaultProps" :data="data"
      style="position: absolute;top: 70px;bottom: 0px;left: 0px;right: 0px;overflow-y: auto;">
    </el-tree>
  </el-card>
</template>

<script>
import { mapState } from "vuex";
import folderService from "@/CommonDP/service/folder-service";
export default {
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    csgetParams: {
      type: Object,
      default: () => ({})
    },
    orderAssistants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultProps: {
        label: "folderName",
        children: "childrenList",
        isLeaf: "leaf"
      },
      show: false,
      loading: false,
      data: [],
      huishouzhan: {
        folderName: "回收站",
        childrenList: []
      },
      notCompleted: false
    };
  },
  computed: {
    ...mapState({
      judgeIsUseNewFolder: (state) => state.enterprise.judgeIsUseNewFolder
    })
  },
  watch: {
    treeData() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },

  created() {},
  methods: {
    async querylist() {
      this.data = [];
      if (!this.judgeIsUseNewFolder) {
        var isCsgetParams = this.csgetParams.orderKey.split(">").every((item) => {
          return this.csgetParams[item + "List"].length > 0;
        });
        if (isCsgetParams) {
          folderService.dynapreview(this.csgetParams).then((res) => {
            if (res.result === "0") {
              this.data = res.data;
              this.data.push(this.huishouzhan);
            }
          });
        } else {
          var item = this.csgetParams.orderKey.split(">");
          for (var i = 0; i < item.length; i++) {
            if (!this.csgetParams[item[i] + "List"].length) {
              if (item[i] === "child") {
                this.$message.warning(this.$titles.child + "不能为空");
                break;
              } else if (item[i] === "stage") {
                this.$message.warning("阶段不能为空");
                break;
              } else if (item[i] === "spec") {
                this.$message.warning("专业不能为空");
                break;
              }
            }
          }
        }
      } else {
        if (this.csgetParams.childrenList.length === 0) {
          return;
        }
        const typeName = this.orderAssistants[this.orderAssistants.length - 1].typeName;
        this.arrangePublishData(this.csgetParams.childrenList, typeName);
        const res = await folderService.dynamicPreview(this.csgetParams);
        this.data = res.data;
        this.data.push(this.huishouzhan);
      }
    },
    arrangePublishData(data, typeName) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].typeName !== typeName) {
          if (data[i].childrenList?.length) {
            this.notCompleted = false;
            this.arrangePublishData(data[i].childrenList, typeName);
          } else {
            this.notCompleted = true;
          }
        }
      }
    },
    // 预览
    async refresh() {
      this.show = false;
      this.loading = true;
      await this.$nextTick();
      try {
        await this.querylist();
      } finally {
        this.show = true;
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  /deep/ .el-card__header {
    padding: var(--middle-space) 0px;
  }
}
</style>
